export const search = (status, textSearch) =>{
 
  
  if (!textSearch) return status;
  
  return status.filter((i) =>
       (i.toDate?.includes(textSearch) || false) ||
       (i.fromDate?.includes(textSearch) || false) ||
       (i.manager?.toLowerCase().includes(textSearch.toLowerCase()) || false) ||
       (i.designer?.toLowerCase().includes(textSearch.toLowerCase()) || false) ||
       (i.order?.toLowerCase().includes(textSearch.toLowerCase()) || false) ||
       (i.client?.[0]?.toLowerCase().includes(textSearch.toLowerCase()) || false)
  );
}

export const searchPrint = (status, textSearch) =>{
 
  if (!textSearch) return status;
  
  return status.map(folder => ({
    ...folder,
    item: folder.item?.filter((i) =>
      (i.toDate?.includes(textSearch) || false) ||
      (i.date?.includes(textSearch) || false) ||
      (i.manager?.toLowerCase().includes(textSearch.toLowerCase()) || false) ||
      (i.designer?.toLowerCase().includes(textSearch.toLowerCase()) || false) ||
      (i.fileName?.toLowerCase().includes(textSearch.toLowerCase()) || false)
    ) || []
  }));
}

export const sortDate = (status, object, isAscending = false) =>{
return status.sort((a, b) => {
    const [dayA, monthA, yearA] = a[object].split('/');
    const [dayB, monthB, yearB] = b[object].split('/');
    
    const diff = (yearB - yearA) || (monthB - monthA) || (dayB - dayA);
    return isAscending ? -diff : diff;
  });
}


export const createState = (state) => {
  const result = [];

  state.forEach((item) => {
    const existingGroup = result.find((group) => group.date === item.data);

    if (existingGroup) {
      // Если дата уже существует, добавляем объект в массив
      existingGroup.items.push(item);
    } else {
      // Если даты нет, создаем новую группу
      result.push({ date: item.data, items: [item] });
    }
  });

  return result;
};
